import "../../Styles/CommunityStyles/purchase.css";
import nftoken from "../../Assets/nftoken.png";

export default function Purchasenft() {
  return (
    <div className="purchasenft">
      <div className="nftContainer">
        <div className="nftTop">
          <div className="nftleft">
            <div className="nftleftTop">
              <div className="headLine"></div>
              <div className="nftheading">nftoken</div>
            </div>
            <div className="nftext">
              NFTOKEN is the token of NFTOWN. There is a total supply of 100
              crores,
              <br />
              we can hold, trade, buy and sell.
            </div>
          </div>
          <div className="nftRight">
            <img src={nftoken} alt="" />
          </div>
        </div>
        <div className="nftbottom">
          <button>PURCHASE NFTOKEN</button>
        </div>
      </div>
    </div>
  );
}
